import registerArtists from './artists'
import registerAuth from './auth'
import registerBfhs from './bfhs'
import registerChannels from './channels'
import registerEpisodes from './episodes'
import registerGenres from './genres'
import registerMembers from './members'
import registerMixes from './mixes'
import registerModels from './models'
import registerPlaylists from './playlists'
import registerSearch from './search'
import registerShows from './shows'
import registerStationPlaylists from './station-playlists'
import registerStreamUrls from './stream-urls'
import registerSubscriptions from './subscriptions'
import registerUploader from './uploader'
import registerVersions from './versions'
import registerFavorites from './favorites'
import registerMessages from './messages'

const registrars = [
    registerArtists,
    registerAuth,
    registerBfhs,
    registerChannels,
    registerEpisodes,
    registerGenres,
    registerMembers,
    registerMixes,
    registerModels,
    registerPlaylists,
    registerSearch,
    registerShows,
    registerStationPlaylists,
    registerStreamUrls,
    registerSubscriptions,
    registerUploader,
    registerVersions,
    registerFavorites,
    registerMessages,
]

export default function registerAll(DataLayer) {
    registrars.forEach(register => register(DataLayer))
}
